import React from "react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { MoreVertical } from "lucide-react";
import { RowActionsDropdownMenu } from "../../components/SimpleTable/RowActionsDropdownMenu";
import type { BaseEntity, SimpleTableConfig, EntityHooks } from "../../types";

interface CardActionMenuProps<TData extends BaseEntity> {
  item: TData;
  config: SimpleTableConfig<TData>;
  hooks: EntityHooks<TData>;
  onClick?: (e: React.MouseEvent) => void;
}

export function CardActionMenu<TData extends BaseEntity>({
  item,
  config,
  hooks,
  onClick,
}: CardActionMenuProps<TData>) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild onClick={onClick}>
        <Button variant="ghost" size="sm" className="h-8 w-8 p-0" title="More options">
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <RowActionsDropdownMenu
        item={item}
        actions={config.detailActions ?? []}
        hooks={hooks}
        entityName={config.entity}
        config={config}
      />
    </DropdownMenu>
  );
}
